export default __webpack_public_path__ + "static/media/pic6.fbae3710.jpg";